"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BirthDatePicker = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_hook_form_1 = require("react-hook-form");
var mona_1 = require("@artegeie/design-system/mona");
var useBirthdate_1 = require("../../../context/useBirthdate");
var UncontrolledBirthDatePicker = function (_a) {
    var _b, _c, _d;
    var 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    name = _a.name, onChange = _a.onChange, value = _a.value;
    var birthdate = {
        day: (_b = value === null || value === void 0 ? void 0 : value.getDate().toString()) !== null && _b !== void 0 ? _b : '',
        month: value ? (value.getMonth() + 1).toString() : '',
        year: (_c = value === null || value === void 0 ? void 0 : value.getFullYear().toString()) !== null && _c !== void 0 ? _c : '',
    };
    var _e = (0, useBirthdate_1.useBirthdate)(birthdate), days = _e.days, months = _e.months, years = _e.years;
    var onDatePickerChange = function (state) {
        var yearAsNumber = Number(state.year);
        var monthAsNumber = Number(state.month);
        var dayAsNumber = Number(state.day);
        if (dayAsNumber && monthAsNumber && yearAsNumber) {
            var date = new Date(yearAsNumber, monthAsNumber - 1, dayAsNumber);
            onChange === null || onChange === void 0 ? void 0 : onChange(date);
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(undefined);
        }
    };
    return (0, jsx_runtime_1.jsx)(mona_1.DatePicker, { days: days, months: months, years: years, onChange: onDatePickerChange, initialValues: birthdate }, "DatePicker_".concat((_d = value === null || value === void 0 ? void 0 : value.toString()) !== null && _d !== void 0 ? _d : 'empty'));
};
var BirthDatePicker = function (_a) {
    var name = _a.name, control = _a.control;
    return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: name, render: function (_a) {
                var field = _a.field;
                return (0, jsx_runtime_1.jsx)(UncontrolledBirthDatePicker, { name: name, onChange: field.onChange, value: field.value }, void 0);
            } }, void 0) }, void 0);
};
exports.BirthDatePicker = BirthDatePicker;
exports.default = exports.BirthDatePicker;
